import { createSelector } from 'reselect';
import { createSelectedFieldsSelector } from '../../selectors/selected-fields-selector.esm.js';

function getSomeFieldsSelected(selectedFields) {
  return (selectedFields === null || selectedFields === void 0 ? void 0 : selectedFields.length) > 0;
}
var createSomeFieldsSelectedSelector = function createSomeFieldsSelectedSelector() {
  var selectedFieldsSelector = createSelectedFieldsSelector();
  return createSelector(selectedFieldsSelector, getSomeFieldsSelected);
};

export { createSomeFieldsSelectedSelector };
//# sourceMappingURL=some-fields-selected-selector.esm.js.map
